import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-clipboard-data fs-1",
  style: {"color":"var(--bs-orange)"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Planilla de participante", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "mb-10 d-flex gap-4" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "card-header py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title gap-3" }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "bi bi-clock-history fs-2",
      style: {"color":"var(--bs-orange)"}
    }),
    /*#__PURE__*/_createElementVNode("h4", null, "Historial de registros")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" })
], -1)
const _hoisted_9 = { class: "card-body p-0" }
const _hoisted_10 = { class: "d-flex gap-2 my-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bts bi bi-unlock-fill fs-3 text-hover-white cursor-pointer p-2 rounded-circle" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "bts bi bi-unlock fs-3 text-hover-white cursor-pointer p-2 rounded-circle" }, null, -1)
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_ModalTraslado = _resolveComponent("ModalTraslado")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.drawerOption,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.drawerOption) = $event)),
      direction: "ltr",
      size: "80%",
      resizable: "",
      onOpened: _ctx.onOpened,
      onClosed: _ctx.onClosed,
      "show-close": false
    }, {
      header: _withCtx(({ close, titleId, titleClass}) => [
        _createElementVNode("h4", {
          id: titleId,
          class: _normalizeClass([titleClass, "fw-bold fs-2 d-flex gap-3 align-items-center"])
        }, _hoisted_4, 10, _hoisted_1),
        _createVNode(_component_el_button, {
          text: "",
          circle: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("i", {
              class: "bi bi-x-lg fs-1",
              onClick: close
            }, null, 8, _hoisted_5)
          ]),
          _: 2
        }, 1024)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_skeleton, {
            animated: "",
            loading: _ctx.loaderPhoto,
            class: "w-auto"
          }, {
            template: _withCtx(() => [
              _createVNode(_component_el_skeleton_item, {
                variant: "image",
                class: "border border-3 border-white w-200px h-200px rounded shadow-sm"
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_image, {
                class: "border border-3 border-white w-200px h-200px rounded shadow-sm",
                src: `${_ctx.REPO}/${_ctx.photo?.ruta}`,
                fit: 'contain'
              }, null, 8, ["src"])
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_el_descriptions, {
            column: 1,
            size: "default",
            class: "rounded w-100",
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_descriptions_item, { label: "ID" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.rowItem?.idperson), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "Documento" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.rowItem?.document_type?.name) + " " + _toDisplayString(_ctx.rowItem?.docnumber), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, {
                label: _ctx.t('gender')
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.rowItem?.gender), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_descriptions_item, { label: "Nombres y apellidos" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.rowItem?.firstname) + " " + _toDisplayString(_ctx.rowItem?.lastname) + " " + _toDisplayString(_ctx.rowItem?.surname), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: _ctx.listPayroll,
              "table-layout": 'auto',
              "scrollbar-always-on": true,
              class: "",
              "header-cell-class-name": "text-fprimary text-uppercase text-center bg-light"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "idpayroll",
                  label: "ID",
                  width: "80",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  label: _ctx.t('acronym'),
                  prop: "abrev"
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.t('institution'),
                  prop: "institution"
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.t('state'),
                  width: "120",
                  align: "center"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("span", {
                      class: _normalizeClass('badge badge-' + row.check?.params)
                    }, _toDisplayString(row.check?.name), 3)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  prop: "created_at",
                  label: _ctx.t('registered'),
                  width: "180",
                  align: "center"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.moment(row.created_at).format("DD/MM/YYYY H:mm:ss")), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  width: "120",
                  label: _ctx.t('options'),
                  fixed: "right"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_10, [
                      (row?.check?.id == '1')
                        ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                            key: 0,
                            width: "300",
                            title: `Liberar de la planilla ${row?.institution}?`,
                            onConfirm: ($event: any) => (_ctx.handlerToRelease(row, 2)),
                            effect: "dark",
                            "cancel-button-type": "info",
                            "confirm-button-type": "danger"
                          }, {
                            reference: _withCtx(() => [
                              _hoisted_11
                            ]),
                            _: 2
                          }, 1032, ["title", "onConfirm"]))
                        : _createCommentVNode("", true),
                      (row?.check?.id == '2')
                        ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                            key: 1,
                            width: "300",
                            title: `Habilitar registro ${row?.institution}?`,
                            onConfirm: ($event: any) => (_ctx.handlerToRelease(row, 1)),
                            effect: "dark",
                            "cancel-button-type": "info",
                            "confirm-button-type": "danger"
                          }, {
                            reference: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 2
                          }, 1032, ["title", "onConfirm"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("i", {
                        class: "bts bi bi-arrow-left-right fs-3 text-hover-white cursor-pointer p-2 rounded-circle",
                        onClick: ($event: any) => (_ctx.oPenModalTraslado(row))
                      }, null, 8, _hoisted_13)
                    ])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, _ctx.loader]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onOpened", "onClosed"]),
    _createVNode(_component_ModalTraslado, {
      ref: "ModalTrasladoRef",
      "item-payroll": _ctx.itemPayroll
    }, null, 8, ["item-payroll"])
  ], 64))
}